import { useEventDashboardTotals } from 'legacy/events/hooks/useEventDashboard';
import EventInfo from '../EventInfo';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { currencyFormat } from 'legacy/common/utils/currency';

const EventDashboardTotals = () => {
  const { t } = useTranslation(['events']);
  const router = useRouter();

  const eventId = router.query.slug as string;
  const { data } = useEventDashboardTotals({ eventId });

  const eventData = [
    {
      label: t('events:dashboard.totals.totalRevenue'),
      value: data?.totalRevenue,
      format: (val) => `${currencyFormat(val)}`
    },
    {
      label: t('events:dashboard.totals.totalRSVPs'),
      value: data?.totalRSVP
    },
    {
      label: t('events:dashboard.totals.totalTicketsSold'),
      value: data?.totalTicketsSold
    },
    {
      label: t('events:dashboard.totals.totalScanned'),
      value: data?.totalTicketsScanned
    },
    {
      label: t('events:dashboard.totals.scannedRate'),
      value: data?.scannedRate,
      format: (val) => `${val}%`
    },
    {
      label: t('events:dashboard.totals.avgSafetyRating'),
      value: data?.avgSafetyRating,
      format: (val) => (val ? `${data?.avgSafetyRating} / 3` : '-')
    }
  ];
  return <EventInfo data={eventData} />;
};

export default EventDashboardTotals;
